import { SalesMonitorActions } from 'constants/ActionsTypesTs'
import { IValidateBarCodeParams } from 'models/Budget'
import {
	IConfirmErrorResponse,
	IConfirmSalesMonitorAction,
	IConfirmSalesMonitorActionError,
	IConfirmSalesMonitorActionSuccess,
	IConfirmSalesMonitorParams,
	IConfirmSalesMonitorResponse,
	IGetSalesMonitorItemsAction,
	IGetSalesMonitorItemsActionSuccess,
	IGetSalesMonitorItemsParams,
	IGetSalesMonitorItemsResponse,
	IGetZonesAction,
	IGetZonesActionSuccess,
	IGetZonesResponse,
	ISelectSalesMonitorAction,
	ISelectSalesMonitorActionError,
	ISelectSalesMonitorActionSuccess,
	ISelectSalesMonitorParams,
	ISelectSalesMonitorResponse,
	IValidateBarCodeMonitorAction,
	IValidateBarCodeMonitorActionError,
	IValidateBarCodeMonitorActionSuccess,
	IValidateBarCodeMonitorErrorResponse,
	IValidateBarCodeMonitorResponse
} from 'models/SalesMonitor'

export const getZones = (): IGetZonesAction => ({
	type: SalesMonitorActions.GET_ZONES
})

export const getZonesSuccess = (
	payload: IGetZonesResponse
): IGetZonesActionSuccess => ({
	type: SalesMonitorActions.GET_ZONES_SUCCESS,
	payload
})

export const getSalesMonitorItems = (
	payload: IGetSalesMonitorItemsParams
): IGetSalesMonitorItemsAction => ({
	type: SalesMonitorActions.GET_SALES_MONITOR_ITEMS,
	payload
})

export const getSalesMonitorItemsSuccess = (
	payload: IGetSalesMonitorItemsResponse
): IGetSalesMonitorItemsActionSuccess => ({
	type: SalesMonitorActions.GET_SALES_MONITOR_ITEMS_SUCCESS,
	payload
})

export const confirmSalesMonitor = (
	payload: IConfirmSalesMonitorParams
): IConfirmSalesMonitorAction => ({
	payload,
	type: SalesMonitorActions.CONFIRM_SALES_MONITOR
})

export const confirmSalesMonitorSuccess = (
	payload: IConfirmSalesMonitorResponse
): IConfirmSalesMonitorActionSuccess => ({
	payload,
	type: SalesMonitorActions.CONFIRM_SALES_MONITOR_SUCCESS
})

export const confirmSalesMonitorError = (
	payload: IConfirmErrorResponse
): IConfirmSalesMonitorActionError => ({
	type: SalesMonitorActions.CONFIRM_SALES_MONITOR_ERROR,
	payload
})

export const validateBarCodeMonitor = (
	payload: IValidateBarCodeParams
): IValidateBarCodeMonitorAction => ({
	type: SalesMonitorActions.VALIDATE_BAR_CODE_MONITOR,
	payload
})

export const validateBarCodeMonitorSuccess = (
	payload: IValidateBarCodeMonitorResponse
): IValidateBarCodeMonitorActionSuccess => ({
	type: SalesMonitorActions.VALIDATE_BAR_CODE_MONITOR_SUCCESS,
	payload
})

export const validateBarCodeMonitorError = (
	payload: IValidateBarCodeMonitorErrorResponse
): IValidateBarCodeMonitorActionError => ({
	type: SalesMonitorActions.VALIDATE_BAR_CODE_MONITOR_ERROR,
	payload
})

export const selectSalesMonitor = (
	payload: ISelectSalesMonitorParams
): ISelectSalesMonitorAction => ({
	type: SalesMonitorActions.SELECT_SALES_MONITOR_ITEMS,
	payload
})

export const selectSalesMonitorSuccess = (
	payload: ISelectSalesMonitorResponse
): ISelectSalesMonitorActionSuccess => ({
	payload,
	type: SalesMonitorActions.SELECT_SALES_MONITOR_ITEMS_SUCCESS
})

export const selectSalesMonitorError = (
	payload: IConfirmErrorResponse
): ISelectSalesMonitorActionError => ({
	payload,
	type: SalesMonitorActions.SELECT_SALES_MONITOR_ITEMS_ERROR
})
